import Sync from '@/components/Sync';
import { useDeepLink } from '@/features/calls';
import { useInviteDeepLink } from '@/features/invite/utils/useInviteDeepLink';
import UseHere from '@/features/useHere/UseHere';
import { lazy, memo } from 'react';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { store } from 'store';
import { ContextProvider } from './app/providers';
import AlertModalRoot from './components/AlertModalRoot';

const CallScreenRouter = lazy(() => import('@/features/calls').then(module => ({ default: module.CallScreenRouter })));
const MainLayout = lazy(() => import('@/layout/MainLayout'));
const LoginRegisterPage = lazy(() => import('@/features/auth/eim'));
const PopupContainer = lazy(() => import('@/components/PopupContainer'));
const FullPageLoader = lazy(() => import('@/components/FullPageLoader'));

const DeepLinkHandler = memo(() => {
   useDeepLink();
   useInviteDeepLink();
   return null;
});

function App() {
   return (
      <Provider store={store}>
         <DeepLinkHandler />
         <ContextProvider>
            <UseHere />
            <PopupContainer />
            <FullPageLoader />
            <Sync>
               <CallScreenRouter>
                  <LoginRegisterPage>
                     <MainLayout />
                  </LoginRegisterPage>
               </CallScreenRouter>
            </Sync>
            {/* AlertModalRoot must be outside CallScreenRouter — when a call is connected,
                CallScreenRouter wraps children in ActivityCompat with display:none, which
                hides all descendants including position:fixed alert modals */}
            <AlertModalRoot />
         </ContextProvider>
         <ToastContainer />
      </Provider>
   );
}

export default App;
